exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tterror {\n    color: red;\n}\n\n.ttwarning {\n    color: rgb(222, 174, 29);\n}", ""]);

